import React, { useEffect, useState } from "react";
import api from "~/services/api";
import CreateEditContent from "./CreateEditContent";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import { Colors } from "~/config/Colors";
import { SLEditModal } from "~/pages/Sistema/componentes/SistemaList";
import { useSelector } from "react-redux";

export default function FluxoProjetos() {
  const [data, setData] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [clientes, setClientes] = useState([]);
  const [analistas, setAnalistas] = useState([]);
  const [idEtapa, setIdEtapa] = useState(6);
  const [tipoVisual, setTipoVisual] = useState("1");
  const [etapas, setEtapas] = useState([]);

  useEffect(() => {
    async function handleRequests() {
      api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
        .then(response => setClientes(response.data));

      api.get("/signed/empresa/gestorprojeto/gerencia/analistas")
        .then(response => setAnalistas(response.data));
    }

    handleRequests();
  }, []);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil, idEtapa, tipoVisual]);

  useEffect(() => {
    api
      .get('/signed/empresa/gestorprojeto/etapa/etapas', {
        params: { ativo: 1, tipo: 'FPJ', projeto: "S" },
      })
      .then(r => {
        setEtapas(r?.data);
      });
      
    setIdEtapa(6);
  }, [tipoVisual]);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-pj"
            requests={{
              findAll: () =>
                api.get('/signed/empresa/gestorprojeto/fluxoprojetos', { params: tipoVisual == "2" ? { idEtapaFluxo: idEtapa } : {} }),
              findOne: thisData =>
                api.get('/signed/empresa/gestorprojeto/fluxoprojeto', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/empresa/gestorprojeto/fluxoprojeto', {
                  data: { id: thisData.id },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            topMain={false}
            informationPage={{
              title: "Fluxo dos Projetos",
              subTitle: "Crie e Gerencie os Fluxos dos Projetos",
              icone: "menu-projetos",
              menu: true,
            }}
            tabFilter={{
              initial: { ativo: true },
              tabAtivo: 1,
              list: [
                {
                  corDestaque: localStorage.getItem("tema") == "E" ? '#9A3636' : '#e68282',
                  corFundo: Colors?.Color8,
                  title: 'Desativado',
                  value: { ativo: false },
                },
                {
                  corDestaque: Colors?.Color4,
                  corFundo: Colors?.Color8,
                  title: "Ativo",
                  value: { ativo: true },
                },
              ],
            }}
            selects={[
              {
                list: clientes,
                value: "id",
                label: "nomeFantasia",
                outLabel: "Todos os Clientes",
                filter: "idCliente",
              },
              {
                list: analistas,
                value: "id",
                label: "nome",
                outLabel: "Todos os Analistas",
                filter: "atividadesAnalista.idAnalista",
              },
            ]}
            inputs={[
              { filter: "titulo", label: "Titulo" },
              { filter: "id", label: "Id" },
              { filter: "cliente.nomeFantasia", label: "Cliente" },
            ]}
            setterModoComponent={() => {
              setTipoVisual(tipoVisual == "1" ? "2" : "1");
            }}
          >
            <SLEditModal menu={true} title={mountedData ? mountedData?.titulo : "Atualizar Projeto"} setter={setMountedData}>
              {mountedData && (
                <CreateEditContent {...{ mountedData }} />
              )}
            </SLEditModal>

            <CustomBodyContent {...{ data, etapas, idEtapa, setIdEtapa, tipoVisual }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
